import { Suspense } from 'react';
import {
  Routes, Route, useNavigate, useLocation, useParams, useSearchParams,
} from 'react-router-dom';
import routes from './routes';

// 统一处理组件渲染：在这里可以做一些权限校验等...处理
function Element(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [usp] = useSearchParams();
  const { component: Component } = props;
  return <Component navigate={navigate} location={location} params={params} usp={usp} />;
}

// 递归创建Route
const createRouter = (routeList) => (
  routeList.map((item, index) => {
    const { path, children } = item;
    return (
      <Route key={index} path={path} element={<Element {...item} />}>
        { Array.isArray(children) ? createRouter(children) : null }
      </Route>
    );
  })
);

// 路由容器
export default function RouterView() {
  return (
    <Suspense>
      <Routes>
        {createRouter(routes)}
      </Routes>
    </Suspense>
  );
}
